import React from 'react'
import styles from './styles.module.css'

const index = ({title}) => {
  return (
    <h1 className={styles.title}>{title}</h1>
  )
}

export default index